import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';

class CheckedOut extends ChemComponent {
  	constructor(props) {
		super(props);
		
		// default past year
		var dtOneYearAgo = this.midnight(new Date());
		dtOneYearAgo.setFullYear(dtOneYearAgo.getFullYear() - 1);
		
		// initialize search
		var search = {
			DATE_OUT_FROM: this.dateTimeToMVC(dtOneYearAgo),
			DATE_OUT_TO: null
		};
		
		// initialize list
		var initCOList = this.copyTable(coList);
		initCOList.query.search = this.constructSearch(search);
		
		this.state = {
			search: search,
			coList: initCOList,
			searchCount: null,
			renderKey: 1,
		};
	}
	
	onChange(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	constructSearch(data) {
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.DATE_OUT_FROM)) search.Children.push({ Attribute: 'DATE_OUT', Operator: '>=', DateValue: data.DATE_OUT_FROM });
		if (!this.isEmpty(data.DATE_OUT_TO)) search.Children.push({ Attribute: 'DATE_OUT', Operator: '<', DateValue: this.nextDayMVC(data.DATE_OUT_TO) });
		
		if (search.Children.length === 0) return null;
		return search;
	}		
	
	onSubmitSearch(event, newOrder) {
		var newCOList = this.copyTable(this.state.coList);
		newCOList.query.search = this.constructSearch(this.state.search);
		if (newOrder) newCOList.query.order = newOrder;
		this.mergeState({ 
			coList: newCOList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Checked Out',
			columns: exportColumns,
			entity: 'REUSE.CHECKED_OUT_VW',
			search: this.constructSearch(this.state.search),
			order: this.copyObject(this.state.coList.query.order)
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Inventory Out</span>
					  <ChemEdit parent={this} user={this.props.user} columns={coSearch} data={this.state.search}
						renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChange(accessor, value)} />
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
							<Button id="search" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
						</Col>
					  </Form.Group>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='Reuse_CheckedOut' table={this.state.coList}
							order={this.state.coList.query.order} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='185px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const coSearch = [
	{ Header: 'Date Out From', accessor: 'DATE_OUT_FROM', type: 'date', row: 0, col: 0 },
	{ Header: 'Date Out To', accessor: 'DATE_OUT_TO', type: 'date', row: 0, col: 1 }
];

const coList = {
	query: { entity: 'REUSE.CHECKED_OUT_VW', order: ['CHEM_NAME'] },
	pageSize: 20,
	columns: [
		{ Header: 'ID', accessor: 'BOTTLE_ID', width: 70 },
		{ Header: 'CAS Number', accessor: 'CAS_NUMBER', width: 110 },
		{ Header: 'Name', accessor: 'CHEM_NAME', width: 500 },
		{ Header: 'Amount', accessor: 'AMOUNT', width: 70 },
		{ Header: 'Brand', accessor: 'BRAND_NAME', width: 250 },
		{ Header: 'Date Out', accessor: 'DATE_OUT_DISPLAY', width: 100 },
		{ Header: 'User', accessor: 'CUSTOMER_NAME', width: 300 },
		{ Header: 'User Group', accessor: 'PI_NAME', width: 200 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'BOTTLE_ID', width: 14 },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER', width: 22 },
	{ Header: 'Name', accessor: 'CHEM_NAME', width: 100 },
	{ Header: 'Amount', accessor: 'AMOUNT', width: 14 },
	{ Header: 'Brand', accessor: 'BRAND_NAME', width: 50 },
	{ Header: 'Date Out', accessor: 'DATE_OUT_DISPLAY', width: 20 },
	{ Header: 'User', accessor: 'CUSTOMER_NAME', width: 60 },
	{ Header: 'User Group', accessor: 'PI_NAME', width: 40 }
];

export default withRouter(CheckedOut);